module.exports = __webpack_public_path__ + "img/bmg10.063de0f3.png";